import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "methodology",
  class: "screen"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "wrapper col-2" }
const _hoisted_4 = { class: "intro" }
const _hoisted_5 = { class: "row-3" }
const _hoisted_6 = { class: "panel col-2" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "panel col-2" }
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = { class: "panel col-2" }
const _hoisted_11 = { class: "icon" }

import CommonShapeAnimation from "@/components/common/CommonShapeAnimation.vue";
import CommonButton from "@/components/common/CommonButton.vue";

import IconBrain from "@/components/icons/IconBrain.vue";
import IconDesign from "@/components/icons/IconDesign.vue";
import IconComplete from "@/components/icons/IconComplete.vue";

import { trackButtonClick } from "@/helpers/analytics.helper";
import { scrollToSection } from "@/helpers/scroll.helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionMethode',
  setup(__props) {

const clickHandler = (name: string) => {
    trackButtonClick(`methodology-header-${name}`);
    scrollToSection(name);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(CommonShapeAnimation, {
      shape: "polygon",
      sides: 3,
      rotation: 75,
      position: "left"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Notre méthode", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", null, [
            _createElementVNode("strong", null, "Une Alchimie créative pour transformer vos idées en succès ?")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", null, [
            _createTextVNode("Voici nos clefs pour mener une idée vers un projet abouti."),
            _createElementVNode("br"),
            _createTextVNode("Contactez-nous dès aujourd’hui et faisons naître ensemble des projets ambitieux et mémorables. ")
          ], -1)),
          _createElementVNode("a", {
            id: "methodology-header-action",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clickHandler('contact'))),
            title: "Contactez-nous"
          }, [
            _createVNode(CommonButton, {
              size: "large",
              icon: "next"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Je me lance", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("article", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(IconBrain)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", null, [
              _createElementVNode("header", null, [
                _createElementVNode("h3", null, "Réflexion")
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, "Une écoute active pour révéler vos besoins.")
              ]),
              _createElementVNode("p", null, "Nous analysons vos idées et vos objectifs pour construire un cadre stratégique et créatif qui met en lumière le potentiel de votre projet.")
            ], -1))
          ]),
          _createElementVNode("article", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(IconDesign)
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", null, [
              _createElementVNode("header", null, [
                _createElementVNode("h3", null, "Structuration")
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, "Quand l’inspiration devient réalité.")
              ]),
              _createElementVNode("p", null, "Avec passion et précision, nous traduisons vos aspirations en maquettes et expériences impactantes. Chaque décision est un pas vers l’excellence.")
            ], -1))
          ]),
          _createElementVNode("article", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(IconComplete)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", null, [
              _createElementVNode("header", null, [
                _createElementVNode("h3", null, "Accomplissement")
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, "L’exécution parfaite.")
              ]),
              _createElementVNode("p", null, "Nous réalisons et peaufinons chaque détail avant de vous livrer un produit prêt à impressionner et à performer.")
            ], -1))
          ])
        ])
      ])
    ])
  ]))
}
}

})